import cleanQueryString from "./cleanQueryString";
import ellipsize from "./ellipsize";

export default { cleanQueryString, ellipsize };
